module.exports = __webpack_public_path__ + "img/39.83b38a66.png";